import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import laptop from "../../images/banner2.png";
import expression from "../../images/banner3.png";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();
  return (
    <>
      <div id="services" className="services-area ptb-100">
        <div className="container">
          <div
            className="saas-section-title"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="100"
          >
            <h2>{t("static.services.title")}</h2>
            <div className="bar"></div>
           
          </div>

          {/* Services Slider */}
          <Swiper
            spaceBetween={15}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 6500,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            }}
            modules={[Pagination, Autoplay]}
            className="services-slides"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="200"
          >
            <SwiperSlide>
              <div className="single-services">
                <div className="icon">
                  <i className="fas fa-solar-panel"></i>
                </div>
                <h3>{t("static.services.title1")}</h3>
                <p>
                  {t("static.services.subtitle1")}
                </p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="single-services">
                <div className="icon bg-cdf1d8">
                  <i className="fas fa-mobile-alt"></i>
                </div>
                <h3>{t("static.services.title2")}</h3>
                <p>
                  {t("static.services.subtitle2")}
                </p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="single-services">
                <div className="icon bg-f78acb">
                  <i className="fas fa-th"></i>
                </div>
                <h3>{t("static.services.title3")}</h3>
                <p>
                  {t("static.services.subtitle3")}
                </p>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        {/* Services Card */}

        <div className="services-inner-area">
          <div className="container-fluid">
            <div className="row h-100 justify-content-center align-items-center svc-container1">
              <div className="col-lg-6 col-md-12">
                <div
                  className="services-image"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                  data-aos-delay="300"
                >
                  <img src={laptop} alt="service" width={1050} height={567} />
                </div>
              </div>

              <div className="col-lg-6 col-md-12">
                <div className="services-inner-content">
                  <div
                    className="services-item"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="400"
                  >
                    <div className="icon">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <h3>{t("static.services.dashboard-title")}</h3>
                    <p>
                      {t("static.services.dashboard-subtitle")}
                    </p>
                  </div>

                  <div
                    className="services-item"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="500"
                  >
                    <div className="icon">
                      <i className="fas fa-list"></i>
                    </div>
                    <h3>{t("static.services.reports-title")}</h3>
                    <p>
                      {t("static.services.reports-subtitle")}
                    </p>
                  </div>

                  <div
                    className="services-item"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="600"
                  >
                    <div className="icon">
                      <i className="fas fa-bell"></i>
                    </div>
                    <h3>{t("static.services.alerts-title")}</h3>
                    <p>
                      {t("static.services.alerts-subtitle")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="services-inner-area">
          <div className="container-fluid">
            <div className="row h-100 justify-content-center align-items-center svc-container2">
              <div className="col-lg-6 col-md-12">
                <div className="services-inner-content">
                  <div
                    className="services-item"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="400"
                  >
                    <div className="icon">
                      <i className="fas fa-database"></i>
                    </div>
                    <h3>{t("static.services.dataset-title")}</h3>
                    <p>
                      {t("static.services.dataset-subtitle")}
                    </p>
                  </div>

                  <div
                    className="services-item"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="500"
                  >
                    <div className="icon">
                      <i className="fas fa-table"></i>
                    </div>
                    <h3>{t("static.services.datasource-title")}</h3>
                    <p>
                      {t("static.services.datasource-subtitle")}
                    </p>
                  </div>

                  <div
                    className="services-item"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="600"
                  >
                    <div className="icon">
                      <i className="fas fa-table-list"></i>
                    </div>
                    <h3>{t("static.services.expressions-title")}</h3>
                    <p>
                      {t("static.services.expressions-subtitle")}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-12">
                <div
                  className="services-image"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                  data-aos-delay="300"
                >
                  <img
                    src={expression}
                    alt="service"
                    width={1050}
                    height={567}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
         {
          `
          .services-inner-area .svc-container1 {
             margin-right: 0;
          }

          .services-inner-area .svc-container2 {
             margin-left: 0;
             margin-right: 5px;
          }
          `
         }
      </style>
    </>
  );
};

export default Services;
